import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

const env = window.__ENV__ ?? {};

window.Echo = new Echo({
    broadcaster: 'reverb',
    key: env.REVERB_APP_KEY,
    wsHost: env.REVERB_HOST,
    wsPort: env.REVERB_PORT ?? 80,
    wssPort: env.REVERB_PORT ?? 443,
    forceTLS: (env.REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});
